/*
 * @Author: bbqin
 * @Date: 2022-01-04 10:27:29
 * @LastEditTime: 2022-08-26 14:11:45
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\TableNext\adapter\utils\handleBeforeEvent.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
export function handleBeforeEvent({ row, column, moduleId, callback, type }) {
    return callback();
}